export { DateTransform as default } from '@ember-data/serializer/transform';
